import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Home extends BaseApi {
    constructor() {
        super({ suffix: "statics" });
    }

    getBar(params) {
        return this.httpService.get("bar", {
            headers,
            params,
        });
    }
    intervalBar(params) {
        return this.httpService.get("interval", {
            headers,
            params,
        });
    }
    getLine(params) {
        return this.httpService.get("line", {
            headers,
            params,
        });
    }
    getPie(params) {
        return this.httpService.get("pie", {
            headers,
            params,
        });
    }
    getDoughnut(params) {
        return this.httpService.get("doughnut", {
            headers,
            params,
        });
    }
    getCount(params) {
        return this.httpService.get("count", {
            headers,
            params,
        });
    }
  getBarCountProjectProvince(params) {
    return this.httpService.get("bar/CountProjectProvince", {
      headers,
      params,
    });
  }
  getPieStateProject(params) {
    return this.httpService.get("pie/StateProject", {
      headers,
      params,
    });
  }
  getDoughnutUnitFrameStruct(params) {
    return this.httpService.get("doughnut/CountUnitFrameStruct", {
      headers,
      params,
    });
  }
  getDoughnutUnitFrameRebuild(params) {
    return this.httpService.get("doughnut/CountUnitFrameRebuild", {
      headers,
      params,
    });
  }
  getBarHorzintalUnitTemplateHinged(params) {
    return this.httpService.get("barHorzintal/CountUnitTemplateHinged", {
      headers,
      params,
    });
  }
  getBarHorzintalUnitTemplateRail(params) {
    return this.httpService.get("barHorzintal/CountUnitTemplateRail", {
      headers,
      params,
    });
  }
  getBarSumBranchProfile(params){

    return this.httpService.get("bar/SumBranchProfile", {
      headers,
      params,
    });
  }
  getStackedSumPiece(params){

    return this.httpService.get("stacked/SumPiece", {
      headers,
      params,
    });
  }
  getOptimal(params){

      return this.httpService.get("optimal", {
      headers,
      params,
    });
  }

  getBarCountWinDoor(params){

    return this.httpService.get("bar/CountWinDoor", {
      headers,
      params,
    });
  }
  getBarCountStypeFitting(params){

    return this.httpService.get("bar/CountStypeFitting", {
      headers,
      params,
    });
  }
  getBarCountPopFitting(params){

    return this.httpService.get("bar/CountPopFitting", {
      headers,
      params,
    });
  }
  getStackedAreaCountGlass(params){

    return this.httpService.get("stacked/AreaCountGlass", {
      headers,
      params,
    });
  }
  getStackedAreaCountNet(params){

    return this.httpService.get("stacked/AreaCountNet", {
      headers,
      params,
    });
  }
}

const HomeService = new Home();
export default HomeService;
